
import { defineComponent } from 'vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Page404',

  components: { CustomButton },

  methods: {
    backToPortalLink() {
      this.$router.push({ name: 'home' });
    }
  }
});
